import { Droplets } from 'lucide-react';

/**
 * Sample type selector component
 */
export function SampleTypeSelector({ sampleType, onChange }) {
  const handleSelect = (type) => {
    onChange({ target: { name: 'sample_type', value: type }});
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Prøvetype *
      </label>
      <div className="grid grid-cols-2 gap-4">
        <button
          type="button"
          onClick={() => handleSelect('algae')}
          className={`p-4 border-2 rounded-lg transition-all ${
            sampleType === 'algae'
              ? 'border-blue-500 bg-blue-50'
              : 'border-gray-200 hover:border-gray-300'
          }`}
        >
          <Droplets className={`w-6 h-6 mx-auto mb-2 ${
            sampleType === 'algae' ? 'text-blue-500' : 'text-gray-400'
          }`} />
          <div className="font-medium">Algeprøve</div>
          <div className="text-xs text-gray-500 mt-1">Fytoplankton analyse</div>
        </button>
        
        <button
          type="button"
          onClick={() => handleSelect('zooplankton')}
          className={`p-4 border-2 rounded-lg transition-all ${
            sampleType === 'zooplankton'
              ? 'border-green-500 bg-green-50'
              : 'border-gray-200 hover:border-gray-300'
          }`}
        >
          <Droplets className={`w-6 h-6 mx-auto mb-2 ${
            sampleType === 'zooplankton' ? 'text-green-500' : 'text-gray-400'
          }`} />
          <div className="font-medium">Zooplankton</div>
          <div className="text-xs text-gray-500 mt-1">Håvtrekk analyse</div>
        </button>
      </div>
    </div>
  );
}
